import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { adminApi } from '../api';
import { Lock, Mail, LogIn, ArrowLeft } from 'lucide-react';
import { toast } from '../hooks/use-toast';

const AdminLogin = () => {
  const [form, setForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await adminApi.login(form.email, form.password);
      localStorage.setItem('trucrunch_admin_token', res.token);
      localStorage.setItem('trucrunch_admin_email', res.email);
      navigate('/admin');
    } catch (err) {
      toast({ title: 'Login failed', description: err?.response?.data?.detail || 'Check your credentials.' });
    } finally {
      setLoading(false);
    }
  };

  const input = 'flex-1 py-3 bg-transparent focus:outline-none font-brico';

  return (
    <div className="min-h-screen bg-[#FFF4E6] flex items-center justify-center px-5">
      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-2 font-brico font-bold text-sm uppercase tracking-widest opacity-70 hover:opacity-100 mb-6">
          <ArrowLeft size={14} /> Back to site
        </Link>
        <div className="bg-white rounded-3xl crunch-shadow p-6 md:p-8">
          <img src="https://customer-assets-cm19k8pv.emergentagent.net/job_trucrunch-games/artifacts/0ug68r65_download.png" alt="TruCrunch" className="h-12 w-auto" />
          <div className="text-xs font-bold uppercase tracking-widest text-[#E63946] mt-6">Admin</div>
          <h1 className="font-display text-4xl uppercase leading-[0.9] mt-1">Sign In</h1>
          <p className="font-brico opacity-70 mt-2 text-sm">Only admins can access the crunch dashboard.</p>

          <form onSubmit={submit} className="mt-6 space-y-3">
            <div className="flex items-center gap-2 bg-[#FFF4E6] rounded-2xl border-2 border-[#1a1a1a] px-4">
              <Mail size={16} />
              <input required type="email" placeholder="Email" className={input} value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
            </div>
            <div className="flex items-center gap-2 bg-[#FFF4E6] rounded-2xl border-2 border-[#1a1a1a] px-4">
              <Lock size={16} />
              <input required type="password" placeholder="Password" className={input} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
            </div>
            <button type="submit" disabled={loading} className="btn-chunky primary w-full justify-center">
              <LogIn size={16} /> {loading ? 'Signing in…' : 'Sign In'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
